import React from "react";
import { Col, Container, Row } from "reactstrap";
import Form from "../component/Form";

import BreadCrumb from "../../../Components/Common/BreadCrumb";

const DisputeClaim = () => {
  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-center align-content-center align-items-center">
        {/* <BreadCrumb title="Customer List" pageTitle="Customer" /> */}
        <Form />
      </div>
      {/* <Navbar /> */}
    </div>
  );
};

export default DisputeClaim;
